// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.deployment.deployment_process_manager.DeploymentProcessManager

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { DeploymentProcessData, DeploymentProcessStore } from "./DeploymentProcess.generated";

export interface DeploymentProcessManagerData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "DeploymentProcessManager";
    processes: DeploymentProcessData[];
}

export class DeploymentProcessManagerStore {
    readonly _entity_class_name = "DeploymentProcessManager" as const;
    processes: DeploymentProcessStore[];
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: DeploymentProcessManagerData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.processes = wrapEntity(data.processes, transport, [...chainPath, "processes"]);
        makeObservable(this, {
            processes: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async begin(name: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "begin", [name], {});
    }
}

registerEntity("DeploymentProcessManager", DeploymentProcessManagerStore);
